import { useLayoutEffect, useState, type RefObject } from 'react';
import { backingSize } from './waveformMath';

/** Track logical layout and monitor/browser-zoom DPR independently of source data. */
export function useCanvasSize(ref: RefObject<HTMLElement | null>, height: number) {
  const [size, setSize] = useState(() => ({ cssWidth: 1, cssHeight: height, dpr: window.devicePixelRatio || 1, ...backingSize(1, height, window.devicePixelRatio || 1) }));
  useLayoutEffect(() => {
    const node = ref.current; if (!node) return;
    let media: MediaQueryList | undefined;
    const measure = () => {
      const cssWidth = Math.max(1, node.getBoundingClientRect().width);
      const dpr = window.devicePixelRatio || 1;
      setSize(previous => previous.cssWidth === cssWidth && previous.dpr === dpr ? previous : { cssWidth, cssHeight: height, dpr, ...backingSize(cssWidth, height, dpr) });
    };
    const watchDpr = () => {
      media?.removeEventListener('change', watchDpr);
      measure();
      media = window.matchMedia?.(`(resolution: ${window.devicePixelRatio || 1}dppx)`);
      media?.addEventListener('change', watchDpr);
    };
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(measure) : undefined;
    observer?.observe(node); watchDpr();
    window.addEventListener('resize', measure);
    return () => { observer?.disconnect(); media?.removeEventListener('change', watchDpr); window.removeEventListener('resize', measure); };
  }, [ref, height]);
  return size;
}
